export const isBrowser: boolean = typeof document !== "undefined"
